import { IPageHeaderBlock, IPageSimpleHeader } from '@features/cms/typescript';
import styles from '@features/cms/components/pages/PageHeaderBlock/PageHeaderSimpleBlock/PageHeaderSimpleBlock.styles';
import Heading from '@components/Heading/Heading';
type PropsType = {
  data: IPageHeaderBlock<IPageSimpleHeader>;
  defaultBackground: string;
  isFirst: boolean;
};
const PageHeaderSimpleBlock = ({
  data,
  defaultBackground,
  isFirst
}: PropsType) => {
  const {
    header
  } = data.headerData;
  return <header id={data.code} sx={styles.section(defaultBackground)} data-testid="page-header-simple-block">
      <div sx={styles.content}>
        <Heading h={isFirst ? 1 : 2} display={4} addSx={styles.heading} mobile>
          {header}
        </Heading>
      </div>
    </header>;
};
export default PageHeaderSimpleBlock;